
import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function Contact() {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const emailBody = `Name: ${formData.firstName} ${formData.lastName}\nEmail: ${formData.email}\nMessage: ${formData.message}`;
      
      const response = await fetch('https://emerichcustom.com/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain',
        },
        body: emailBody,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Could not send email.');
      }

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
      });

    } catch (error) {
      console.error(error.message);
    }

    setShowSuccessPopup(true);
  };


  return (
    <Container maxWidth="md" style={{padding: '90px'}}>
      <Typography variant="h4" component="h2" gutterBottom>
        Contact Us
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={4}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              type="submit"
            >
              Send
            </Button>
          </Grid>
        </Grid>
      </form>

      <Dialog open={showSuccessPopup} onClose={() => setShowSuccessPopup(false)}>
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <Typography>Form sent</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowSuccessPopup(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Contact;
